/**
 * Extensions are usually defined the structure and casing as shown below:
 * <hr>
 * `<system>/StructureDefinition/<resourceName>-<extensionName>`
 */
export enum ExtensionUrl {
  //Address
  addressEmergencyAccess = 'http://quromedical.com/fhir/StructureDefinition/address-emergencyAccess',
  addressLongitude = 'http://quromedical.com/fhir/StructureDefinition/address-longitude',
  addressLatitude = 'http://quromedical.com/fhir/StructureDefinition/address-latitude',
  addressGooglePlaceId = 'http://quromedical.com/fhir/StructureDefinition/address-googlePlaceId',

  // patient
  /**
   * @deprecated we are no longer defining patients using a static risk value
   */
  riskClassification = 'https://quromedical.co.za/StructureDefinition/patient-riskClassification',
  /**
   * @deprecated ICD10 Codes should instead be stored on the Encounter as the `reasonCode`
   */
  admissionICD10Code = 'https://quromedical.co.za/StructureDefinition/patient-admissionICD10Code',
  medicalAidAuthorizationCode = 'https://quromedical.co.za/StructureDefinition/patient-medicalAidAuthorizationCode',
  latestStatus = 'https://quromedical.co.za/StructureDefinition/patient-latestStatus',
  /**
   * @deprecated we are now storing the assigned organization in the general-practitioner field
   */
  assignedOrganization = 'https://quromedical.co.za/StructureDefinition/patient-assignedOrganization',

  // encounter
  encounterOxygenRate = 'https://quromedical.co.za/StructureDefinition/encounter-oxygenRate',
  encounterAttachment = 'https://quromedical.co.za/StructureDefinition/encounter-attachment',
  encounterHospitalizationSchemeCode = 'https://quromedical.co.za/StructureDefinition/encounter-hospitalizationSchemeCode',
  encounterHospitalizationSubscriberId = 'https://quromedical.co.za/StructureDefinition/encounter-hospitalizationSsubscriberId',
  encounterHospitalizationDependentCode = 'https://quromedical.co.za/StructureDefinition/encounter-hospitalizationDependentCode',
  encounterHospitalizationAuthorizationDate = 'https://quromedical.co.za/StructureDefinition/encounter-hospitalizationAuthorizationDate',

  // practitioner
  initialGroup = 'https://quromedical.co.za/StructureDefinition/practitioner-initialGroup',
  medicationRequestPrescriber = 'https://quromedical.co.za/StructureDefinition/practitioner-medicationRequestPrescriber',

  // clinical impression
  clinicalImpressionNoteCode = 'https://quromedical.co.za/StructureDefinition/clinicalimpression-noteCode',
  clinicalImpressionLocationCode = 'https://quromedical.co.za/StructureDefinition/clinicalimpression-locationType',
  clinicalImpressionAssessmentCode = 'https://quromedical.co.za/StructureDefinition/clinicalimpression-assessmentCode',
  clinicalImpressionPlanCode = 'https://quromedical.co.za/StructureDefinition/clinicalimpression-planCode',
  clinicalImpressionPinned = 'https://quromedical.co.za/StructureDefinition/clinicalimpression-pinned',
  clinicalImpressionStructuredContentJSON = 'https://quromedical.co.za/StructureDefinition/clinicalimpression-structuredContentJSON',
  clinicalImpressionSummarySection = 'https://quromedical.co.za/StructureDefinition/clinicalimpression-summarySection',

  // observation
  /**
   * @deprecated vital capture time should instead be stored on the Observation as `effectiveDateTime`
   */
  observationComponentDateTime = 'https://quromedical.co.za/StructureDefinition/observation-componentDateTime',
  /**
   * @deprecated deviceId/sensorId should instead be stored on the Observation as `device`
   */
  observationComponentSensorId = 'https://quromedical.co.za/StructureDefinition/observation-componentSensorId',

  // extension to any resource at the top-level
  practitionerToNotify = 'https://quromedical.co.za/StructureDefinition/resource-practitionerToNotify',

  // supply delivery
  supplyDeliveryTransportCost = 'https://quromedical.co.za/StructureDefinition/supplyDelivery-transportCost',
  supplyDeliveryTransportCostFactor = 'https://quromedical.co.za/StructureDefinition/supplyDelivery-transportCostFactor',

  claimItemChargeItemDefinition = 'https://quromedical.co.za/StructureDefinition/claim-itemChargeItemDefinition',

  claimResponseItemTraceNumber = 'https://quromedical.co.za/StructureDefinition/claimresponse-itemTraceNumber',

  medicationUsageGroupIdentifier = 'https://quromedical.co.za/StructureDefinition/medicationusage-groupIdentifier',

  moneyFactor = 'https://quromedical.co.za/StructureDefinition/money-factor',

  // Encounter
  encounterPrimaryIcd10Code = 'https://quromedical.co.za/StructureDefinition/encounter-primaryIcd10Code',

  // Service Request
  serviceRequestCopyPractitioners = 'https://quromedical.co.za/StructureDefinition/servicerequest-copyPractitioners',

  // Task
  TaskRequestedPeriod = 'https://quromedical.co.za/StructureDefinition/task-requestedPeriod',
  TaskRequestedPerformer = 'https://quromedical.co.za/StructureDefinition/task-requestedPerformer',

  //Observation
  observationReferenceRangeComparator = 'https://quromedical.co.za/StructureDefinition/observation-referenceRangeComparator',

  //RiskAssessment
  riskAssessmentRiskScore = 'https://quromedical.co.za/StructureDefinition/riskassessment-riskScore',

  //FlagNote
  flagNote = 'https://quromedical.co.za/StructureDefinition/flag-note',

  //Telecom
  whatsappEnabled = 'https://quromedical.co.za/StructureDefinition/whatsappEnabled',
}
